<template>
  <v-menu nudge-bottom="28" nudge-left="100" v-model="menuOpen">
    <template #activator="{ on, attrs }">
      <v-btn
        class="mx-1"
        v-bind="attrs"
        rounded
        color="primary"
        small
        v-on="on"
      >
        <v-badge
          dot
          overlap
          :value="isNewNotificationsPresent"
          color="error"
          offset-x="6"
        >
          <v-icon> mdi-bell </v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card width="fit-content">
      <v-card-title>
        <span class="text-body-1">
          Notifications ({{ notificationCount }})
        </span>
      </v-card-title>
      <v-card-text>
        <v-list two-line>
          <v-list-item
            class="px-0"
            v-for="(notification, index) in notifications"
            :key="index"
          >
            <v-list-item-avatar class="">
              <v-icon color="info">mdi-information</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span class="text-body-2">{{ notification.tittleEn }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="text-body-2">{{
                  formatDate(notification.createdAt, "DD-MMM-YYYY hh:mm a")
                }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDate } from "@/core/methods/formatDate.js";
export default {
  data() {
    return {
      menuOpen: false,
      notifications: [],
      notificationCount: 0
    };
  },

  computed: {
    isNewNotificationsPresent() {
      if (this.notifications.length > 0) {
        for (const notification of this.notifications) {
          if (notification.isNewNotification) {
            return true;
          }
        }
      }
      return false;
    },
    ...mapGetters(["appSettings"])
  },

  methods: {
    formatDate: formatDate
  },
  apollo: {
    getUserNotification() {
      if (this.appSettings.adminUserId == null) return;
      return {
        query: require("@/core/api/queries/get_user_notifications.graphql"),
        pollInterval: 180000,
        variables: {
          userId: this.appSettings.adminUserId,
          input: {
            limit: 50,
            skip: 0
          }
        },
        result({ data }) {
          if (data)
            if (data.getUserNotification.notifications) {
              this.notifications = data.getUserNotification.notifications;
              this.notificationCount = data.getUserNotification.totalCount;
            }
        }
      };
    }
  }
};
</script>

<style scoped></style>
